import { EncryptionAccessLogEntity } from '../entities/';
import { authResource } from './Auth';
import { paginatedSchema } from '../utils/schemas';
export const EncryptionAccessLogResource = authResource({
    path: '/encryptions/:encryptionId/accesslogs/:accessLogId?',
    searchParams: {},
    schema: EncryptionAccessLogEntity
}).extend('getList', {
    schema: paginatedSchema(EncryptionAccessLogEntity)
});
